import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import '../../../i18n'
import Checkbox from '../../UI/Checkbox/Checkbox';
import ErrorBox from '../../UI/ErrorBox/ErrorBox';
import { APIGet, getEnvironment } from '../../API/APIRequest';
import { useParams } from 'react-router';
import DOMPurify from 'dompurify';

export function MarketingPreferences(props, errorStates) {
    const { t, i18n } = useTranslation();
    const [isChecked, setIsChecked] = useState(false);
    const [cleanDpaQuestionHtml, setCleanDpaQuestionHtml] = useState([]);
    const [dpa, setDpa] = useState("");
    const { environment } = useParams();
   
    const loadDPA = async () => {
   
        await APIGet({
            "controller": "auth",
            "action": "getregistrationdpa",
            "environment": environment,
        })
            .then(function (response) {
                let dpa= response.data?.dpaquestion;
                CheckForDpaQuestionText(dpa?.questiontext); 
                cleanDpaText(dpa?.questiontext) //checking if dpa question text is blank
                setDpa(dpa); //this is also async..so may take time so directly pass in the function.
                setIsChecked(dpa?.defaultticked);
            })
            .catch(function (error) {
              
            })
    }

    const CheckForDpaQuestionText=(dpa)=>{
       
        let div = document.createElement('div');
        
        div.innerHTML = dpa;
        
        let textContent = div.textContent;  
        
        let trimmedText = textContent.trim();  
        
        //check for blank question text
        if(trimmedText===""){
            props.setIsDpaQuestionTextBlank("true");
        }else{
            props.setIsDpaQuestionTextBlank("false");
        }

    }

    useEffect(() => {

        loadDPA();

    }, [])

    const cleanDpaText=(dpa)=>{
        const cleanDpaHtml = DOMPurify.sanitize(dpa, {
            ALLOWED_ATTR: ['target', 'href', 'class', 'id', 'style'], // Add any other allowed attributes here
          });

        setCleanDpaQuestionHtml(cleanDpaHtml); 
    }

    useEffect(() => {
        props.setIsMarketingPreferencesChecked(isChecked);
        if (isChecked) {
            props.setErrorStates(errorStates => ({ ...errorStates, marketingPreferencesNotTicked: false }))
        }

    }, [isChecked])

    return (<>{(dpa?.questiontext && props.isDpaQuestionTextBlank==="false") &&
    <div className="item-container">
        <label className="label">{t('marketingpreferences.title')}</label>
        <div className="item-wrapper">
            <Checkbox label={<div dangerouslySetInnerHTML={{ __html: cleanDpaQuestionHtml }} />} checked={isChecked} onChange={() => { setIsChecked(!isChecked) }} id="marketingprefconsent" name="marketingprefconsent" />
            {props.errorStates.marketingPreferencesNotTicked ?
                <span role="alert" id='payment-not-selected'><ErrorBox>{t('payment.marketingpreferencesnotticked')}</ErrorBox></span>
                : ""}
        </div>
    </div>
    }
    </>);
}
